/**
 * Fiksumyynnin julkinen markkinointiosoite (fiksumyynti.fi ja www.fiksumyynti.fi)
 * osoittaa samaan CloudFront-jakeluun kuin sovellus. Juuriosoitteessa etusivu
 * ohjataan infosivulle, sovellusosoitteessa (dev./app.fiksumyynti.fi) kirjautumiseen.
 */
const MARKETING_HOSTS = ['fiksumyynti.fi', 'www.fiksumyynti.fi'];

/** Sovelluksen osoite, johon juuriosoitteen "Kirjaudu sisään" vie. Asetetaan buildissa (deploy.yml, AppHost). */
const APP_URL: string = (import.meta.env.REACT_APP_LOGIN_URL as string | undefined) || 'https://app.fiksumyynti.fi/';

export const isMarketingHost = (hostname: string = window.location.hostname): boolean =>
    MARKETING_HOSTS.includes(hostname.toLowerCase());

/** Kirjautumissivun osoite: juuriosoitteessa ohjataan sovellusosoitteeseen, muuten sovelluksen juureen */
export const getLoginUrl = (): string => (isMarketingHost() ? APP_URL : '/');
